import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=556e6d40"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556e6d40')) {
      api.createRecord('556e6d40', component.options)
    } else {
      api.reload('556e6d40', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=556e6d40", function () {
      api.rerender('556e6d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/template/components/Modal.vue"
export default component.exports